export default "__VITE_ASSET__oNbUVw1L__"